/**
 * Footer component script class
 *
 * @package    Common
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class Footer extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        text: PropTypes.string,
    };

    /**
     * @type {Object}
     */
    static defaultProps = {
        text: '',
    };

    render () {
        const { text } = this.props;

        if (!text) {
            return null;
        }

        return (
            <footer className="registration-site-footer" role="contentinfo">
                <div className="row">
                    <div className="col-12">
                        <div className="registration-site-footer-horizontalrule-block">
                            <hr/>
                        </div>
                        <div className="registration-site-footer-html-block">
                            { text }
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}
